import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

export const SectionTitle = styled.h2`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: ${vimovaTheme.fontSizes.large};
  color: ${vimovaTheme.colors.primary};
  margin: 0;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: ${vimovaTheme.fontSizes.large} !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SectionSubtitle = styled.p`
  font-family: ${vimovaTheme.fonts.body};
  font-weight: ${vimovaTheme.fontWeights.normal};
  font-size: ${vimovaTheme.fontSizes.body};
  color: ${vimovaTheme.colors.textLight};
  margin: 4px 0 0 0;

  @media print {
    font-size: ${vimovaTheme.fontSizes.body} !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
